<div id="dialog" #dialog class="dialog" role="dialog" aria-modal="true" tabindex="-1"
    [attr.aria-label]="dialogService.dialogTitle" [class.show]="dialogService.show" [ngClass]="dialogService.panelClass">
    <div class="dialog-content">
        <div class="title" [ngClass]="{'draggable': dialogService.draggable}" (mousedown)="startDrag($event)">
            <div class="left">{{ dialogService.dialogTitle }}</div>
            <div [innerHTML]="dialogService.topRightCornerHTML$ | async" class="right"></div>
        </div>
        <div class="injected-component">
            <ng-template dialogHost></ng-template>
        </div>
        <div class="footer">
            <div *ngIf="(dialogService.message$ | async) as message" class="message fade-in" [innerHtml]="message">
            </div>
            <div class="actions">

                <button type="button"
                    *ngIf="dialogService.secondaryButtonText"
                    data-testid="dialog-secondary-button"
                    (click)="secondary()"
                    [disabled]="!(dialogService.secondaryButtonEnabled$ | async)"
                    [ngClass]="{'disabled': !(dialogService.secondaryButtonEnabled$ | async)}"
                    class="button secondary">
                    {{dialogService.secondaryButtonText}}</button>

                <button type="button" *ngIf="dialogService.submitButtonText" data-testid="dialog-submit-button" (click)="submit()"
                    [disabled]="!(dialogService.submitButtonEnabled$ | async)" [ngClass]="{
                        'disabled': !(dialogService.submitButtonEnabled$ | async)
                    }" class="button right">
                    {{dialogService.submitButtonText}}
                </button>
                <button type="button" (click)="closeDialog()"
                    data-testid="dialog-close-button"
                    [disabled]="!(dialogService.closeButtonEnabled$ | async)"
                    [ngClass]="{'right': !dialogService.submitButtonText, 'disabled': !(dialogService.closeButtonEnabled$ | async)}"
                    class="button">close</button>
            </div>
        </div>
    </div>
</div>
